import { UpdateInternetMessageIdName } from 'owa-mail-compose-action-names';
import { action } from 'satcheljs/lib/legacy';
export default action(UpdateInternetMessageIdName)(function updateInternetMessageIdAction(conversationId, itemId, internetMessageId) {
    // No-op
    // This is called to raise a stitch set up by owa-mail-reading-pane.
});
//# sourceMappingURL=updateInternetMessageId.js.map